const HOST_API_ROUTE = `${process.env.REACT_APP_CHAT_API_ROUTE}`;

const SETTING_API_ROUTE = `${HOST_API_ROUTE}/setting`;


export const GET_SETTINGS_API_ROUTE = `${SETTING_API_ROUTE}/get-settings`;
 
export const SAVE_SETTING_API_ROUTE = `${SETTING_API_ROUTE}/save-setting`;

export const DELETE_SETTING_API_ROUTE = `${SETTING_API_ROUTE}/delete-setting-by-id?settingId=`;

export const GET_GLOBAL_SETTINGS = `${SETTING_API_ROUTE}/get-global-settings`;
